import { IFailMessage } from 'dialer/classes/models/models'
import { isInstanceOf } from 'src/core/utils/functions'

const checkIsFailMessage = (obj: any) => 'field' in obj && 'message' in obj && 'type' in obj

export function checkIsFailMessages(messages: any): messages is IFailMessage[] {
  return isInstanceOf<IFailMessage[]>(
    messages,
    (items: any) => Array.isArray(items) && items.every((i) => checkIsFailMessage(i))
  )
}
